import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  /** 引导按钮（三处空状态必须有可点的下一步） */
  action?: ReactNode;
  icon?: ReactNode;
}

/** 空状态：必须给「为什么空 + 下一步做什么」，不允许只显示一句"暂无数据"。 */
export function EmptyState({ title, description, action, icon = '◌' }: EmptyStateProps) {
  return (
    <div className="empty">
      <div className="empty-icon" aria-hidden="true">
        {icon}
      </div>
      <div className="empty-title">{title}</div>
      {description !== undefined ? <p className="empty-desc">{description}</p> : null}
      {action !== undefined ? <div className="row">{action}</div> : null}
    </div>
  );
}